/**
 * The bar that says you are not yourself.
 *
 * An administrator can open a driver's own screen and work in it — close a
 * trip for someone whose phone is dead, see exactly what they see. Everything
 * on that screen then behaves as it does for the driver, which is the point
 * and also the danger: without this bar there is nothing to tell you that the
 * "Megérkeztem" you are about to tap will be recorded as their arrival.
 *
 * So it is deliberately hard to miss and hard to lose:
 *
 *  - it sits ABOVE the screen's own content, on every portal page, for as
 *    long as the session is assumed;
 *  - it is drawn from the SESSION (`assumed_by_email` comes back from the
 *    API on every /portal/session), not from anything this tab remembers, so
 *    a reload, a restored tab or a stale client cannot leave somebody working
 *    in a driver's name with the bar gone;
 *  - its way out is a button, not a back gesture, because leaving is a thing
 *    you should have to mean.
 *
 * `onStop` returns to the board. The caller owns that, since only it knows
 * where the board is.
 */
import React from 'react';

export default function AssumedDriverBar({ driverName, onStop }) {
  return (
    <div className="pp-assumed" role="status">
      <div className="pp-assumed__text">
        <span className="pp-assumed__label">Viewing as</span>
        <span className="pp-assumed__who">{driverName || 'this driver'}</span>
        <span className="pp-assumed__note">
          Anything you do here is recorded as theirs.
        </span>
      </div>
      <button type="button" className="pp-assumed__stop" onClick={onStop}>
        Stop
      </button>
    </div>
  );
}
